import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProductoService } from '../../producto/producto.service';
import { CompraService } from '../compra.service';

@Component({
  selector: 'app-compra-create',
  templateUrl: './compra-create.component.html',
  styleUrls: ['./compra-create.component.scss']
})
export class CompraCreateComponent implements OnInit {

  constructor(
  ) {}

  ngOnInit(): void {
  }

}
